import { mdiMenu } from '@mdi/js';
import Icon from '@mdi/react';
import IconButton from './IconButton';
import "./ButtonMenu.linaria.module.css!=!./ButtonMenu?./ButtonMenu.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNz8mPNywzqzIzLNFD5VYXJKakZOal65bkF1iZF1RY13JBVKSiakjF0JCUX1KSn4uiJxtVTzaGnpzUtBIUHTmoOnIwdBRlpmfAtAAAxJKjR8oAAAA="
const buttonStyles = "atm_lo_1v6z61t atm_le_1v6z61t atm_lk_1v6z61t atm_ll_1v6z61t";
interface IButtonMenu {
  onClick(event?: any): void;
  title?: string;
}
const ButtonMenu = ({
  onClick,
  title
}: IButtonMenu) => <IconButton title={title ?? 'Menu'} onClick={onClick} className={buttonStyles}>
        <Icon path={mdiMenu} size={1} data-testid="MenuIcon" />
    </IconButton>;
export default ButtonMenu;